import { useEffect, useState } from 'react';
import { api, type CostSummary } from '../api';

export function CostDashboard() {
  const [rows, setRows] = useState<CostSummary[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.costDashboard().then((result) => {
      setRows(result.rows);
      setTotal(result.total_cost_usd);
    }).catch(() => {
      setRows([]);
      setTotal(0);
    });
  }, []);

  return (
    <section className="panel">
      <div className="metric-row">
        <div>
          <span>Total cost</span>
          <strong>${total.toFixed(2)}</strong>
        </div>
        <div>
          <span>Ceiling</span>
          <strong>$10 local</strong>
        </div>
        <div>
          <span>Phase</span>
          <strong>0+1</strong>
        </div>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Provider</th>
              <th>Calls</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.provider}>
                <td>{row.provider}</td>
                <td>{row.calls}</td>
                <td>${row.total_cost_usd.toFixed(4)}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={3}>No paid API calls recorded.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
